"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledComboboxEmptyState = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Paragraph = require("../Paragraph/Paragraph");
var StyledComboboxEmptyState = /*#__PURE__*/(0, _styledComponents.default)(_Paragraph.Paragraph).withConfig({
  displayName: "StyledComboboxEmptyState",
  componentId: "c11n-8-107-0__sc-lsfax2-0"
})([""]);
exports.StyledComboboxEmptyState = StyledComboboxEmptyState;